import FiveStarsIcon from './five-stars.svg';

export { FiveStarsIcon };

import aslanJpg from './aslan.jpg';
import aslanWebp from './aslan.webp';

import busterJpg from './buster.jpg';
import busterWebp from './buster.webp';

import candyJpg from './candy.jpg';
import candyWebp from './candy.webp';

import charleyJpg from './charley.jpg';
import charleyWebp from './charley.webp';

import duncanJpg from './duncan.jpg';
import duncanWebp from './duncan.webp';

import elvisJpg from './elvis.jpg';
import elvisWebp from './elvis.webp';

import francisJpg from './francis.jpg';
import francisWebp from './francis.webp';

import gabiJpg from './gabi.jpg';
import gabiWebp from './gabi.webp';

import ghostJpg from './ghost.jpg';
import ghostWebp from './ghost.webp';

export const aslanSources = {
  jpg: aslanJpg,
  webP: aslanWebp,
};

export const busterSources = {
  jpg: busterJpg,
  webP: busterWebp,
};

export const candySources = {
  jpg: candyJpg,
  webP: candyWebp,
};

export const charleySources = {
  jpg: charleyJpg,
  webP: charleyWebp,
};

export const duncanSources = {
  jpg: duncanJpg,
  webP: duncanWebp,
};

export const elvisSources = {
  jpg: elvisJpg,
  webP: elvisWebp,
};

export const francisSources = {
  jpg: francisJpg,
  webP: francisWebp,
};

export const gabiSources = {
  jpg: gabiJpg,
  webP: gabiWebp,
};

export const ghostSources = {
  jpg: ghostJpg,
  webP: ghostWebp,
};
